import { connect } from 'react-redux';
import { activeShopMinInterval } from '../../auth/selectors';

const mapStateToProps = checkIfProvided => (state, ownProps) => ({
  minInterval: (!checkIfProvided || !ownProps.minInterval) ? activeShopMinInterval(state) : ownProps.minInterval,
});

export const withMinIntervalIfNotProvided = connect(mapStateToProps(true));

export default connect(mapStateToProps(false));
